/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MonoListAsset } from '../models/MonoListAsset';
import type { MonoListDisplayParameter } from '../models/MonoListDisplayParameter';
import type { MonoListProcessedAssetData } from '../models/MonoListProcessedAssetData';
import type { MonoListSite } from '../models/MonoListSite';
import type { MonoPaginatedAssets } from '../models/MonoPaginatedAssets';
import type { ToolsenseDailyDataDTO } from '../models/ToolsenseDailyDataDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CustomToolsenseResourceService {

    /**
     * Retrieves a list of all Toolsense Sites
     * Retrieves a list of all Toolsense Sites
     * @returns MonoListSite OK
     * @throws ApiError
     */
    public static getSitesData(): CancelablePromise<MonoListSite> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/toolsense/sites-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Retrieves all parameter values of all Assets
     * Retrieves all parameter values of all Assets
     * @param assetId The ID of toolsense asset to filter by
     * @param parameterId The ID of toolsense category parameter to filter by
     * @param from Timestamp in milliseconds of start date
     * @param to Timestamp in milliseconds of end date
     * @returns MonoListProcessedAssetData OK
     * @throws ApiError
     */
    public static getParameterValues(
        assetId: string,
        parameterId: string,
        from?: number,
        to?: number,
    ): CancelablePromise<MonoListProcessedAssetData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/toolsense/parameterValues',
            query: {
                'assetId': assetId,
                'parameterId': parameterId,
                'from': from,
                'to': to,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Retrieves all Toolsense asset parameters name and id
     * Retrieves all Toolsense asset parameters name and id
     * @param assetId The ID of toolsense asset to filter by
     * @returns MonoListDisplayParameter OK
     * @throws ApiError
     */
    public static getAssetParametersIds(
        assetId: string,
    ): CancelablePromise<MonoListDisplayParameter> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/toolsense/parameterIds',
            query: {
                'assetId': assetId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Retrieves a paginated list of Toolsense asset contract data
     * Retrieves all Toolsense paginated asset contract data
     * @returns MonoPaginatedAssets OK
     * @throws ApiError
     */
    public static getAllAssetContractData(): CancelablePromise<MonoPaginatedAssets> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/toolsense/contract-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Retrieves daily data for the specified asset and parameter
     * Retrieves daily data for the specified asset based on the provided parameter display name, dates, and synthetic parameter
     * @param assetId The ID of Toolsense asset to filter by
     * @param parameterName The name of asset parameter to filter by
     * @param from Timestamp start date
     * @param to Timestamp end date
     * @param timezone The time zone to filter by
     * @returns ToolsenseDailyDataDTO OK
     * @throws ApiError
     */
    public static getAssetDailyData(
        assetId: string,
        parameterName: string,
        from: string,
        to: string,
        timezone: string,
    ): CancelablePromise<Array<ToolsenseDailyDataDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/toolsense/asset-daily-data',
            query: {
                'assetId': assetId,
                'parameterName': parameterName,
                'from': from,
                'to': to,
                'timezone': timezone,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Retrieves all Toolsense asset ids
     * Retrieves all Toolsense asset ids
     * @returns MonoListAsset OK
     * @throws ApiError
     */
    public static getAssetIds(): CancelablePromise<MonoListAsset> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/toolsense/allAssetIds',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Retrieves a paginated list of Toolsense assets
     * Retrieves all Toolsense paginated Assets list
     * @param offset
     * @param first
     * @returns MonoPaginatedAssets OK
     * @throws ApiError
     */
    public static getAllPaginatedData(
        offset: number,
        first: number,
    ): CancelablePromise<MonoPaginatedAssets> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/toolsense/all-paginated-data',
            query: {
                'offset': offset,
                'first': first,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Retrieves a paginated list of Toolsense customer data
     * Retrieves all Toolsense paginated Assets customer data
     * @returns MonoPaginatedAssets OK
     * @throws ApiError
     */
    public static getAllCustomerData(): CancelablePromise<MonoPaginatedAssets> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/toolsense/all-customer-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
                503: `Service Unavailable`,
            },
        });
    }

}
